'use client';

import { useAdyen } from '../../hooks';
import type { AdyenFormProps } from './types';

import '@adyen/adyen-web/dist/adyen.css';
import './AdyenForm.scss';

export function AdyenForm({ setAdyenForm, setAdyenFormState }: AdyenFormProps) {
    const { adyenForm, adyenFormState } = useAdyen();

    setAdyenForm(adyenForm);
    setAdyenFormState(adyenFormState);

    return (
        <div className="adyen-form" data-testid="adyen-form">
            <div id="adyen-card-container" data-cs-mask />
        </div>
    );
}
